module.exports = __webpack_public_path__ + "dimer/static/img/2.177f4f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/2.jpg
// module id = mwzy
// module chunks = 0